export default function(...args) {
  return args.filter((a) => !!a).join(' ');
}
